import useCurrentProject from '@/biz/useCurrentProject.mjs'
import { useFilterByLicense } from '@/biz/license.jsx'
import { useFilterByEnabledModelOfCurrentProject } from '@/biz/enabledModel.mjs'

const getBdBoda1 = (currentProject, filterByModel) => {
    return 'BODA1' === currentProject?.subTypeCode ?
        filterByModel('BD', {
            title: '业务能力模块',
            to: ['/BdList'],
        })
        :
        null
}

const getBdBoda2 = (currentProject, filterByModel) => {
    return 'BODA1' === currentProject?.subTypeCode ?
        null
        :
        filterByModel('BD', {
            title: '程序模块',
            to: ['/BdBoda2List'],
        })
}

const getDataMap = (currentProject, filterByModel) => {
    const type = 'BODA1' === currentProject?.subTypeCode ? 'BIZ_MAP' : 'SF_MAP'

    return filterByModel(type, {
        title: '数据地图',
        to: ['/ProjectDataMap'],
    })
}

export default () => {
    const filterByLicense = useFilterByLicense()
    const filterByModel = useFilterByEnabledModelOfCurrentProject()
    const [currentProject] = useCurrentProject()
    const bdBoda1 = getBdBoda1(currentProject, filterByModel)
    const bdBoda2 = getBdBoda2(currentProject, filterByModel)
    const dataMap = getDataMap(currentProject, filterByModel)

    return filterByLicense('M00010005', {
        title: '模型管理',

        children: [
            filterByModel('SA_MAP', {
                title: '模型总图',
                to: ['/SaList'],
            }),

            {
                title: '模型集成图',

                children: [
                    filterByModel('ORG_MAP', {
                        title: '组织地图',
                        to: ['/ProjectOrgMap'],
                    }),

                    filterByModel('BF_MAP', {
                        title: '知识地图',
                        to: ['/ProjectBfMap'],
                    }),

                    filterByModel('BIZ_MAP', {
                        title: '业务地图',
                        to: ['/ProjectBizMap'],
                    }),

                    filterByModel('ANA_MAP', {
                        title: '分析地图',
                        to: ['/ProjectAnaMap'],
                    }),

                    // dataMap,

                    filterByModel('SF_MAP', {
                        title: '功能地图',
                        to: ['/ProjectSfMap'],
                    }),

                    filterByModel('UI_MAP', {
                        title: '界面地图',
                        to: ['/ProjectUiMap'],
                    }),

                    filterByModel('INF_MAP', {
                        title: '接口地图',
                        to: ['/ProjectInfMap'],
                    }),

                    filterByModel('UC_MAP', {
                        title: '用例地图',
                        to: ['/ProjectUcMap'],
                    }),

                    filterByModel('DATA_MAP', {
                        title: '库表地图',
                        to: ['/ProjectDbMap'],
                    }),

                    filterByModel('FC_MAP', {
                        title: '程序地图',
                        to: ['/ProjectFcMap'],
                    }),
                ],
            },

            {
                title: '模型制品',
                to: ['/DpList'],
            },

            {
                title: '模型模件',
                to: ['/ModuleList'],
            },

            {
                title: '分类制品',

                children: [
                    {
                        title: '组织制品',

                        children: [
                            filterByModel('OA', {
                                title: '组织结构',
                                to: ['/OaList'],
                            }),

                            filterByModel('OO', {
                                title: '组织对象',
                                to: ['/OoList'],
                            }),
                        ],
                    },

                    {
                        title: '流程制品',

                        children: [
                            // filterByModel('PA', {
                            //     title: '流程结构',
                            //     to: ['/PaList'],
                            // }),

                            filterByModel('BF', {
                                title: '业务流程',
                                to: ['/BfList'],
                            }),
                        ],
                    },

                    {
                        title: '业务制品',

                        children: [
                            filterByModel('BA', {
                                title: '业务结构',
                                to: ['/BaList'],
                            }),

                            bdBoda1,
                        ],
                    },

                    {
                        title: '分析制品',

                        children: [
                            filterByModel('AA', {
                                title: '分析结构',
                                to: ['/AaList'],
                            }),

                            filterByModel('DO', {
                                title: '维度对象',
                                to: ['/DoList'],
                            }),

                            filterByModel('AO', {
                                title: '分析对象',
                                to: ['/AoList'],
                            }),

                            filterByModel('AMAI', {
                                title: '分析指标',
                                to: ['/AmAiList'],
                            }),

                            filterByModel('AMAR', {
                                title: '分析报表',
                                to: ['/AmArList'],
                            }),
                        ],
                    },

                    {
                        title: '知识制品',

                        children: [
                            filterByModel('PA', {
                                title: '知识结构',
                                to: ['/PaList'],
                            }),

                            filterByModel('RULEMRM', {
                                title: '知识模块',
                                to: ['/RulemRmList'],
                            }),
                        ],
                    },

                    // {
                    //     title: '知识模块',
                    //     to: ['/RulemRmList'],
                    // },

                    {
                        title: '功能制品',

                        children: [
                            filterByModel('FA', {
                                title: '功能结构',
                                to: ['/FaList'],
                            }),

                            bdBoda2,

                            filterByModel('BDLOGIC', {
                                title: '程序能力',
                                to: ['/BdLogicList'],
                            }),

                            filterByModel('SF', {
                                title: '系统功能',
                                to: ['/SfList'],
                            }),
                        ],
                    },

                    {
                        title: '界面制品',

                        children: [
                            filterByModel('UA', {
                                title: '入口结构',
                                to: ['/UaList'],
                            }),

                            filterByModel('UI', {
                                title: '用户界面',
                                to: ['/UiList'],
                            }),
                        ],
                    },

                    {
                        title: '接口制品',

                        children: [
                            filterByModel('LS', {
                                title: '外联系统',
                                to: ['/LsList'],
                            }),

                            filterByModel('LSI', {
                                title: '外联接口',
                                to: ['/LsiList'],
                            }),
                        ],
                    },

                    {
                        title: '用例制品',

                        children: [
                            filterByModel('CA', {
                                title: '用例结构',
                                to: ['/CaList'],
                            }),

                            filterByModel('UC', {
                                title: '集成用例',
                                to: ['/UcList'],
                            }),
                        ],
                    },

                    {
                        title: '库表制品',

                        children: [
                            filterByModel('DB', {
                                title: '数据库',
                                to: ['/DbList'],
                            }),

                            filterByModel('DT', {
                                title: '数据表',
                                to: ['/DtList'],
                            }),

                            filterByModel('DV', {
                                title: '数据视图',
                                to: ['/DvList'],
                            }),

                            filterByModel('CDT', {
                                title: '定制数据类型',
                                to: ['/CdtList'],
                            }),

                            filterByModel('CDG', {
                                title: '标准字段',

                                children: [
                                    {
                                        title: '标准字段组',
                                        to: ['/DmPcdgList'],
                                    },

                                    {
                                        title: '引用标准的标准字段',
                                        to: ['/DmPcdgDfByCdgList'],
                                    },

                                    {
                                        title: '引用标准的表字段',
                                        to: ['/DmPcdgDfByDtList'],
                                    },
                                ],
                            }),
                        ],
                    },

                    {
                        title: '程序制品',

                        children: [
                            filterByModel('SS', {
                                title: '子系统',
                                to: ['/SsList'],
                            }),

                            filterByModel('FC', {
                                title: '程序能力',
                                to: ['/FcList'],
                            }),

                            filterByModel('DTO', {
                                title: 'DTO',
                                to: ['/DtoList'],
                            }),

                            filterByModel('MID', {
                                title: '中间件',
                                to: ['/ArchMiddlewareList'],
                            }),
                        ],
                    },

                    {
                        title: '部署制品',

                        children: [
                            filterByModel('PHYS', {
                                title: '物理机',
                                to: ['/DepPsList'],
                            }),

                            filterByModel('VR', {
                                title: '虚拟机',
                                to: ['/DepVsList'],
                            }),
                        ],
                    },
                ],
            },

            filterByLicense('M00010006', {
                title: '模型成品',
                to: ['/PrjPatternList'],
            }),

            filterByLicense('M00030003', {
                title: '模型分支',
                to: ['/PrjBaseLineList'],
            }),
        ]
    })
}
